// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"303":"0781c604","969":"0781c604"}[chunkId] + ".chunk.css";
};